module.exports = __webpack_public_path__ + "assets/img/240_course_finished.63052b11.png";